import { TodoListWrapper } from '@iso/containers/Todo/Todo.styles';
import { Col, Row, Typography } from 'antd';
import { useApi } from '../../Dashboard/CustomHooks/useApi';
import { useEffect, useState } from 'react';
import "./AIAgent.style.css";


export default function AIChatHistory({ open }) {
    const [data, setData] = useState([]);
    useEffect(() => {
        // fetch(`${process.env.REACT_APP_AI_CHAT_ENDPOINT}/api/workspace/testing/threads`, {
        //     method: "GET",
        //     headers: {
        //         "Content-Type": "application/json",
        //         "Authorization": process.env.REACT_APP_AI_CHAT_KEY
        //     },
        // }).then(async (res) => {
        //     const result = await res.json();
        //     setData(result.threads || []);
        // }).catch((err) => {
        //     console.log("Error");
        // });
    }, []);
    return <TodoListWrapper className={("chat-history" + (open ? "-expanded" : "-collapsed"))}>
        {/* <Typography.Title level={5}>Chat History</Typography.Title> */}
        <Row>
            {data.map((item, idx) => {
                return <Col key={item.slug} style={{padding: "10px", borderTop: idx === 0 && "1px solid #e9e9e9", borderBottom: "1px solid #e9e9e9", cursor: "pointer", width: "100%"}}>
                    {item.name}
                </Col>
            })}
        </Row>
    </TodoListWrapper>
}